module.exports = __webpack_public_path__ + "img/pc_main_bg.53cd154.webp";